import { render, staticRenderFns } from "./VoucherHistory.vue?vue&type=template&id=87ef2e64"
import script from "./VoucherHistory.vue?vue&type=script&lang=js"
export * from "./VoucherHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports